import { render } from "./LessonCatsTopic3.vue?vue&type=template&id=574f6f59"
import script from "./LessonCatsTopic3.vue?vue&type=script&lang=js"
export * from "./LessonCatsTopic3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__